import React from "react";
import AppImages from "../../../../../../constants/images";

const VideoDisplayCard = React.memo(({ helpVideo, onVideoSelect, isSelected }) => {
  return (
    <div
      className={`ai-collection-link-block ${isSelected ? "selected-Video-hover" : ""}`}
    >
      <div className="ai-collection-info-block">
        <div className="ai-block-header">
          <img
            src={AppImages.HelpDisplayIcon}
            loading="lazy"
            alt="Video Icon"
            className="ai-block-icon"
          />
          <h3 className="h3 small">{helpVideo.name}</h3>
        </div>
        <p className="help-video-desc">{helpVideo.name}</p>
        <div className="ai-button-wrapper">
          <div
            onClick={() => onVideoSelect(helpVideo.url)}
            className="button w-button"
          >
            Play Video
          </div>
        </div>
      </div>
    </div>
  );
});

export default VideoDisplayCard;
